import React, { useEffect } from 'react';

import {
  AppBar,
  Box,
  CircularProgress,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';

import BackIcon from '@material-ui/icons/ArrowBack';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { stackActions } from '../store/stack/actions';

import { ApplicationState } from '../store';
import RegistrationFlow from '../components/registrationFlow/RegistrationFlow';
import { MessageSnackbar } from '../components/MessageSnackbar';

const useStyles = makeStyles((theme) => ({
  rootBox: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  appBar: {
    padding: 0,
  },
  appBarOffset: theme.mixins.toolbar,
  loading: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backButton: {
    marginRight: 20,
    cursor: 'pointer',
  },
  title: {
    flexGrow: 1,
  },
}));

interface DetailParams {
  stackId: string;
}

function Detail(): React.ReactElement {
  const { t } = useTranslation(['translations']);
  const dispatch = useDispatch();
  const { stackId } = useParams<DetailParams>();
  const classes = useStyles();

  const { departmentId, measurementCard, values } = useSelector(
    (state: ApplicationState) => {
      const department = state.user.selectedDepartment;

      if (!department) {
        return {};
      }

      const departmentId = department.id;
      const measurementCard =
        state.stacks.departments[departmentId]?.measurementCard;
      const values = state.stacks.departments[departmentId]?.fieldValues;

      return { departmentId, measurementCard, values };
    },
  );

  useEffect(() => {
    if (departmentId && stackId) {
      dispatch(stackActions.loadStackValues(departmentId, stackId));
    }
  }, [stackId, departmentId]);

  const backButtonClicked = () => {
    history.back();
  };

  return (
    <Box className={classes.rootBox}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <BackIcon
            onClick={backButtonClicked}
            className={classes.backButton}
          />
          <Typography variant="h6" className={classes.title}>
            {t('detail_page.title')}
          </Typography>
        </Toolbar>
      </AppBar>
      <div className={classes.appBarOffset} />
      {!(measurementCard && values) && (
        <Box className={classes.loading}>
          <CircularProgress color="secondary" />
        </Box>
      )}
      {measurementCard && values && values.length === 0 && (
        <Box className={classes.loading}>{t('detail_page.no_data')}</Box>
      )}
      {measurementCard && values && values.length > 0 && (
        <RegistrationFlow
          measurementCard={measurementCard}
          disabled={true}
        ></RegistrationFlow>
      )}
      <MessageSnackbar />
    </Box>
  );
}

export default Detail;
